import type { SupplementLabelResponse } from '@/domain/SupplementLabel';
import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';

export const getOrderLabelQuery = (
  orderId: number,
  itemIds: Array<number> = [],
) =>
  queryOptions({
    queryKey: queryKeys.orders.label(orderId, itemIds),
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      for (const id of itemIds) {
        searchParams.append('item_ids[]', String(id));
      }

      return await api
        .get(`orders/${orderId}/label`, {
          ...(itemIds.length > 0 ? { searchParams } : {}),
        })
        .json<SupplementLabelResponse>();
    },
    enabled: orderId > 0,
  });
